import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

async function bootstrap() {
  // MSW is gated by VITE_USE_MSW alone — it is NOT gated by DEV, on purpose.
  //
  // The Docker stack (docker-compose.yml) builds this SPA in production mode to
  // mirror the Heroku dyno, and the Aula/Topico toggle of "Registrar estudo"
  // depends on /manual_entries/suggestions returning the new shape, which Rails
  // does not implement yet. Gating on DEV would tree-shake the mock out of that
  // build and leave the toggle dead at localhost:8080, so the compose file passes
  // VITE_USE_MSW=true as a build arg instead.
  //
  // /manual_entries/suggestions is now the ONLY reason this gate exists: both
  // /app/analise-metricas and /app/analise-progresso are served by Rails today.
  // Quando aquele endpoint entregar o formato novo, todo este bloco (e a build arg
  // do compose) pode sair junto com src/mocks/.
  //
  // This is safe for the real deploy because Heroku builds this repo with a
  // buildpack reading .env.production, which does NOT define VITE_USE_MSW — the
  // variable is undefined there, the branch is dead code, and Vite drops it.
  // Keep it that way: never add VITE_USE_MSW to .env.production or to a Heroku
  // config var. Unhandled requests are bypassed, so only the endpoints declared
  // in src/mocks/browser.ts are faked — the rest still hits the real API.
  if (import.meta.env.VITE_USE_MSW === 'true') {
    const { worker } = await import('./mocks/browser')
    await worker.start({
      onUnhandledRequest: 'bypass',
      serviceWorker: { url: '/mockServiceWorker.js' },
    })
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

void bootstrap()
